// extracted by mini-css-extract-plugin
export default {"rec1":"Hamburger_rec1__JksbM","rec2":"Hamburger_rec2__I0YmM","rec3":"Hamburger_rec3__sU8Pf","clicked":"Hamburger_clicked__+0u5j","hamburger":"Hamburger_hamburger__e3YO5"};